<template>

    <v-list-item class="export">
        <transition name="modal">
            <v-modal-export-delete v-if="showModal === 'delete-' + model.id" :model="model" @deleted="$emit('deleted')" />
        </transition>
        <div class="export-info">
            <span>{{ model.name }}</span><br>
            <span v-if="model.uploaded_at" class="small text-success">Complete</span>
            <span v-else class="small text-danger">Processing...</span>
        </div>
        <div class="d-flex align-items-center justify-content-end">
            <span class="small text-muted">Created {{ model.created_at | dateTime }}</span>
            <v-button-toolbar class="ml-15" size="sm" v-if="model.uploaded_at">
                <v-button size="sm" btn-style="secondary" @click.native="downloadExport" :loading="loading">Download</v-button>
                <v-dropdown
                    type="secondary"
                    label="More"
                    :items="[{ key: 'delete', value: 'Delete Export' }]"
                    :show-selected="false"
                    :menu-right="true"
                    @change="onActionSelected">
                </v-dropdown>
            </v-button-toolbar>
        </div>
    </v-list-item>

</template>

<script>

import ExportApi from '@api/ExportApi';
import ModalExportDelete from '@modals/misc/ModalExportDelete';

export default {

    components: {
        'v-modal-export-delete': ModalExportDelete,
    },

    props: {
        model: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            loading: false,
        }
    },

    methods: {

        onActionSelected(item) {
            if (item.key === 'delete') {
                this.$store.commit('showModal', 'delete-' + this.model.id);
            }
        },

        downloadExport() {
            this.loading = true;
            ExportApi.downloadExport(this.model.id)
                .then((response) => {
                    this.loading = false;
                    window.open(response.data.data);
                }, () => {
                    this.loading = false;
                });
        },

    },

}

</script>
